import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  input: {
    fontSize: '13px',
  },
  underline: {
    border: 'none',
  },
}));
